import React from 'react'
import Reflux from 'reflux-react-16'

import _ from 'lodash'
import moment from 'moment'

import OrderStore from '../stores/OrderStore.js'
import OrderActions from '../actions/OrderActions.js'
import AddressStore from '../../src/stores/AddressStore.js'
import geolocation from '../utils/geolocation.js'
import utils from '../utils/utils.js'
import questionOptions from '../utils/questionOptions.js'
import routeFixedZone from '../../utils/routeFixedZone.js'
import stopBundles from '../../utils/stopBundles.js'

import {ScrollContainer} from '../components/UI/index.js'
import {Address, AddressBundle, SelectRoutePopup} from '../components/index.js'
import {Button, IconButton, Popup, Panel, ListItem, H6, Popover, P, Row, Colors, Alert, Spinner, SortableList, H5, Tabs, Tab} from '../../src/components/UI/index.js'
import {formSpacing, FormStack} from '../../src/components/UI/forms/index.js'
import ChooseRoutePoint from 'messenger/components/ChooseRoutePoint.js'
import NextStopETA from '@components/routes/NextStopETA.js'
import ColliNotReadyPopup from '@components/UI/ColliNotReadyPopup.js'
import AddAddressModal from '@components/AddAddressModal.jsx'
import {emit} from 'messenger/socketio/socketEmit.js'
import t from 'src/helpers/Languages.js'
import {resolveMessengerRouteSettings} from '../../utils/routeAdjustability.js'
import {canEditCompletedAddress} from '../../utils/messengerEditCompletedAddress.js'
import {messengerEndPointTime} from '../../utils/messengerEndPointTime.js'

export default class AddressList extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {
            activeTab: 'all',
            editRoute: false
        }

        this.stores = [OrderStore, AddressStore]
    }

    componentDidMount() {
        localStorage.lastView = '/koerier/adressen'

        if (this.state.isScanning && this.state.route?.openColliCount) {
            this.setState({activeTab: 'open'})
        }
    }

    async onClickLoadRoute() {
        try {
            let {route, shift, location} = this.state
            const {reseller} = this.props

            const orderColli = {}

            route.colli.map((collo) => {
                if (!collo.started) {
                    orderColli[collo.orderId] = orderColli[collo.orderId] || []
                    orderColli[collo.orderId].push(collo)
                }
            })

            if (!await this.popup.open('Route inladen', 'Weet je zeker dat je deze route wilt inladen?')) return

            OrderActions.loadRoute(route._id, orderColli, async (err, errors) => {
                if (err) {
                    this.popup.setError(err)
                } else if (errors.length) {
                    this.popup.setErrors(errors)
                } else {
                    this.popup.close()

                    const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'other')?.id

                    if (shift && activityId) {
                        if (!location?.lat) {
                            location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                        }

                        try {
                            await emit('shifts.startActivity', {id: shift._id, activityId, location})
                        } catch (error) {
                            console.error(error)
                        }
                    }
                }
            })
        } catch (err) {
            await this.popup.setError(err.message || err?.toString())
        }
    }

    async onClickStart() {
        try {
            let {route, shift, location} = this.state
            const {reseller, branding} = this.props

            const gpsRequired = _.some(route.orders, (order) => {
                return _.some(order.addresses, (address) => address.gpsRequired)
            })

            if (gpsRequired) {
                await geolocation.checkPermissions()
            }

            const orderColli = {}
            const colliNotReady = []

            route.colli.map((collo) => {
                if (!collo.started && collo.ready) {
                    orderColli[collo.orderId] = orderColli[collo.orderId] || []
                    orderColli[collo.orderId].push(collo)
                }

                if (!collo.ready) {
                    colliNotReady.push(collo)
                }
            })

            const startUnloadedColli = !route?.loadingRequiredBeforeStart && (!route.loaded || Object.keys(orderColli).length === 0)

            const startRoute = async () => {
                const startRouteAction = () => {
                    OrderActions.startRoute(route._id, startUnloadedColli, async (err, errors) => {
                        if (err) {
                            this.popup.setError(err)
                        } else if (errors.length) {
                            this.popup.setErrors(errors)
                        } else {
                            this.popup.close()

                            const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'route')?.id

                            if (shift && activityId) {
                                if (!location?.lat) {
                                    location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                }

                                try {
                                    await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                } catch (error) {
                                    console.error(error)
                                }
                            }
                        }
                    })
                }

                const routeNotOptimized = route.addresses.some((address) => typeof address.priority !== 'number')

                if (reseller.settings.routeNotOptimizedWarning === 'notallowed' && routeNotOptimized) {
                    this.popup.setActionButtons([{
                        variant: 'solid',
                        color: branding?.color || Colors.brandColor,
                        label: t('optimizeAndStart'),
                        onClick: async () => {
                            try {
                                await emit('orders.planRoute', {routeId: route._id, optimize: true})
                                this.popup.close()
                                startRouteAction()
                            } catch (err) {
                                this.popup.setError(err.message || err.toString())
                            }
                        }
                    }])
                    if (!await this.popup.open('Route starten', 'Route is niet geoptimaliseerd. Optimaliseer de route voordat je deze start.')) return
                    return
                } else if (reseller.settings.routeNotOptimizedWarning === 'warning' && routeNotOptimized) {
                    this.popup.setWarning('Route is niet geoptimaliseerd. Wil je de route toch starten?')
                    if (!await this.popup.open('Route starten')) return
                    startRouteAction()
                } else {
                    if (!await this.popup.open('Route starten', 'Weet je zeker dat je deze route wilt starten?')) return
                    startRouteAction()
                }
            }

            if (!startUnloadedColli && colliNotReady.length > 0) {
                this.colliNotReadyPopup.open(colliNotReady, startRoute, () => {
                    this.setState({loading: false})
                })
            } else {
                startRoute()
            }
        } catch (err) {
            await this.popup.setError(err.message || err?.toString())
        }
    }

    // Opens a single stop or a bundle of stops
    async onClickPickupDeliver(address, barcode) {
        const {history, reseller} = this.props

        const deviation = utils.nextStopDeviation(reseller, address)

        if (deviation === 'notallowed') {
            await this.popup.openAlert('Let op!', 'Dit adres is niet de volgende stop van de route.')
        } else if (deviation === 'warning') {
            if (await this.popup.openBoolean('Let op!', `Dit adres is niet de volgende stop van de route. Wil je deze toch nu ${address.type === 'pickup' ? 'ophalen' : 'bezorgen'}?`, questionOptions())) {
                history.push(stopBundles.stopPath(address), {barcode})
            }
        } else {
            history.push(stopBundles.stopPath(address), {barcode})
        }
    }

    async onClickEditCompletedAddress(address) {
        const {history} = this.props

        const edit = await this.popup.openBoolean(t('editAddress'), t('editCompletedAddressWarning'), questionOptions({cancelLabel: t('cancel'), confirmLabel: t('continue')}))

        if (edit) {
            history.push(`/koerier/${address.type === 'pickup' ? 'ophalen' : 'bezorgen'}/${address.orderId}/${address.index}`, {edit: true})
        }
    }

    async onClickSelectRoute() {
        const {date, routes, selectedRoute} = this.state
        const {history} = this.props

        const {newDate, newSelectedRoute} = await this.selectRoutePopup.open(date, routes, selectedRoute)

        if (newDate !== date) {
            OrderActions.setDate(newDate)
        } else if (newSelectedRoute !== selectedRoute) {
            OrderActions.selectRoute(newSelectedRoute)
            history.push('/koerier/route')
        }
    }

    render() {
        const {loading, customers, addressBook, date, shift, routes, route, editRoute, isScanning, routeUpdatedNotifcation} = this.state
        const {reseller, user, history, branding, onClickNavigation} = this.props

        // While editing the route a bundle is one row and is moved as a whole
        const editRouteItems = []

        route?.addresses?.forEach((address) => {
            const bundle = address.bundleId && route.todoItems?.find((item) => item.id === address.bundleId)

            if (!bundle) {
                editRouteItems.push(address)
            } else if (!editRouteItems.includes(bundle)) {
                editRouteItems.push(bundle)
            }
        })

        const loadedColli = route?.colli?.filter((collo) => (!route.started || !collo.started) && collo.ready)

        const currentActivity = shift && reseller.settings.shifts?.activities?.find((activity) => activity.id === shift.activityId)
        const shiftStartRequired = (reseller.settings.shifts?.shiftRequired && (!shift || !shift?.started || shift?.paused || shift?.completed)) || currentActivity?.lockAppActivity

        // The planner's fixed zone can only be changed by the messenger when deviating from the route order is allowed for it
        const fixedZoneLocked = route?.anchorsEnabled && reseller.settings.nextStopWarning === 'notallowedanchored'

        const messengerRouteSettings = resolveMessengerRouteSettings(route, reseller.settings)
        const routeAdjustableByMessenger = messengerRouteSettings.adjustableByMessenger
        const allowAddAddress = messengerRouteSettings.allowAddAddress

        return (
            <>
                {!editRoute && !isScanning &&
                    <Panel style={{display: 'flex', gap: 6, width: '100%', padding: '12px 6px 12px 6px', borderTop: 'none', borderRight: 'none', borderLeft: 'none'}}>
                        <div style={{width: 36}}>
                            <IconButton
                                onClick={this.onClickSelectRoute.bind(this)}
                                badge={Object.values(routes).filter((r) => !r.completed && r._id !== route._id).length}
                            >
                                <i className='mdi mdi-map-marker-path' />
                            </IconButton>
                        </div>

                        <div style={{flex: 1}}>
                            {route?.loadingRequiredBeforeStart && !route.loaded && !route.started &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-barcode-scan'
                                    label='Route inladen'
                                    disabled={date !== moment().format('YYYY-MM-DD') || _.keys(routes).length === 0 || shiftStartRequired}
                                    onClick={async () => {
                                        let {location} = this.state

                                        OrderActions.startScanning()
                                        history.push('/koerier/adressen')

                                        const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'loading')?.id

                                        if (shift && activityId) {
                                            if (!location?.lat) {
                                                location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                            }

                                            try {
                                                await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                            } catch (error) {
                                                console.error(error)
                                            }
                                        }
                                    }}
                                />
                            }

                            {(route?.loadingRequiredBeforeStart ? route.loaded : route.loaded ? !route.started : (route.hasReadyToStartColli || (route.hasUnstartedColli && !route.hasStartedColli))) &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-arrow-right-bold-circle'
                                    label='Route starten'
                                    disabled={date !== moment().format('YYYY-MM-DD') || !route.hasReadyToStartColli || shiftStartRequired}
                                    onClick={this.onClickStart.bind(this, route.ids)}
                                />
                            }

                            {!route.completed && (route.loaded ? route.started : (!route.hasReadyToStartColli && route.hasStartedColli)) &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-flag-checkered'
                                    label='Route afronden'
                                    disabled={route.hasUnCompletedColli || shiftStartRequired}
                                    onClick={() => {
                                        this.popup.open('Route afronden', 'Weet je zeker dat je deze route wilt afronden?', () => {
                                            let {location} = this.state

                                            OrderActions.stopRoute(route._id, async (err, errors) => {
                                                if (err) {
                                                    this.popup.setError(err)
                                                } else if (errors.length) {
                                                    this.popup.setErrors(errors)
                                                } else {
                                                    this.popup.close()
                                                    history.push('/koerier/route')

                                                    const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'other')?.id

                                                    if (shift && activityId) {
                                                        if (!location?.lat) {
                                                            location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                                        }

                                                        try {
                                                            await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                                        } catch (error) {
                                                            console.error(error)
                                                        }
                                                    }
                                                }
                                            })
                                        })
                                    }}
                                />
                            }
                        </div>

                        <div style={{width: 36}}>
                            <Popover
                                placement='left'
                                popoverStyle={{width: 200}}
                                content={
                                    <>
                                        <ListItem
                                            icon='mdi mdi-barcode-scan'
                                            disabled={date !== moment().format('YYYY-MM-DD') || _.keys(routes).length === 0 || !route.hasUnstartedColli || shiftStartRequired}
                                            onClick={async () => {
                                                let {location} = this.state

                                                OrderActions.startScanning()

                                                const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'loading')?.id

                                                if (shift && activityId) {
                                                    if (!location?.lat) {
                                                        location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                                    }

                                                    try {
                                                        await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                                    } catch (error) {
                                                        console.error(error)
                                                    }
                                                }
                                            }}
                                        >
                                            Route inladen
                                        </ListItem>

                                        <ListItem
                                            icon='mdi mdi-reorder-horizontal'
                                            disabled={!route || !route.addresses?.length || !routeAdjustableByMessenger || shiftStartRequired || route.completed}
                                            onClick={() => {
                                                OrderActions.setRouteReady(route._id, false, (err) => {
                                                    if (err) {
                                                        this.popup.open('Foutmelding')
                                                        this.popup.setError(err)
                                                    }

                                                    this.setState({editRoute: true})
                                                })
                                            }}
                                        >
                                            Route wijzigen
                                        </ListItem>

                                        <ListItem
                                            icon='mdi mdi-home-plus-outline'
                                            disabled={!allowAddAddress || shiftStartRequired || route.completed}
                                            onClick={() => this.addAddressModal.open(shift?.customerId)}
                                        >
                                            Adres toevoegen
                                        </ListItem>
                                    </>
                                }
                            >
                                <IconButton>
                                    <i className='mdi mdi-dots-vertical' />
                                </IconButton>
                            </Popover>
                        </div>
                    </Panel>
                }

                {!isScanning && !route.started && route.loaded &&
                    <Alert style={{marginBottom: 6}} variant='info'>
                        {`Inladen afgerond: ${loadedColli.length} van ${route.colli.length} colli ingeladen`}
                    </Alert>
                }

                {isScanning &&
                    <Panel style={{display: 'flex', gap: 6, width: '100%', padding: '12px 6px 12px 6px', borderTop: 'none', borderRight: 'none', borderLeft: 'none'}}>
                        <div style={{width: 36}} />

                        <div style={{flex: 1}}>
                            <Button
                                variant='solid'
                                color={branding?.color || Colors.brandColor}
                                style={{flex: 1}}
                                label='Inladen afronden'
                                icon='mdi mdi-check'
                                onClick={() => this.onClickLoadRoute()}
                            />
                        </div>

                        <div style={{width: 36}}>
                            <IconButton onClick={() => OrderActions.cancelScanning()}>
                                <i className='mdi mdi-close' />
                            </IconButton>
                        </div>
                    </Panel>
                }

                {editRoute &&
                    <Panel style={{display: 'flex', flexDirection: 'column', width: '100%', padding: '12px 6px 12px 6px', borderTop: 'none', borderRight: 'none', borderLeft: 'none'}}>
                        <Row style={{flexShrink: 0, alignItems: 'center'}}>
                            <Row style={{flexShrink: 0, flex: 1}} />

                            <Row style={{flexShrink: 0, justifyContent: 'center', alignItems: 'center'}}>
                                <H5 style={{marginBottom: 0}}>Route wijzigen</H5>
                            </Row>

                            <Row style={{flexShrink: 0, flex: 1, justifyContent: 'flex-end'}}>
                                <IconButton onClick={() => this.setState({editRoute: false})}>
                                    <i className='mdi mdi-close' />
                                </IconButton>
                            </Row>
                        </Row>

                        <div style={{flex: 1}}>
                            <Row style={{flexShrink: 0, columnGap: formSpacing.columnGap, paddingTop: 12, paddingBottom: 12}}>
                                <Button
                                    style={{flex: 1}}
                                    variant='outline-white'
                                    icon='mdi mdi-map-marker-path'
                                    label='Optimaliseer'
                                    labelPosition='bottom'
                                    disabled={loading || route?.ready}
                                    onClick={() => {
                                        this.setState({loading: true})
                                        OrderActions.planRoute(route._id, true, false, null, (err) => {
                                            this.setState({loading: false, error: err})
                                        })
                                    }}
                                />

                                <Button
                                    style={{flex: 1}}
                                    variant='outline-white'
                                    icon='mdi mdi-swap-vertical'
                                    label='Omdraaien'
                                    labelPosition='bottom'
                                    disabled={loading || route?.ready || !route?.reversible || route?.anchorsEnabled}
                                    onClick={() => {
                                        this.setState({loading: true})
                                        OrderActions.planRoute(route._id, false, true, null, (err) => {
                                            this.setState({loading: false, error: err})
                                        })
                                    }}
                                />
                            </Row>

                            <Row style={{flexShrink: 0, columnGap: formSpacing.columnGap, paddingTop: 12, paddingBottom: 12}}>
                                <Button
                                    style={{flex: 1}}
                                    variant='outline-white'
                                    icon={_.some(route?.addresses, (address) => !address.locked) ? 'mdi mdi-lock' : 'mdi mdi-lock-open-variant-outline'}
                                    label={_.some(route?.addresses, (address) => !address.locked) ? 'Vergrendel' : 'Ontgrendel'}
                                    labelPosition='bottom'
                                    disabled={loading || route?.ready || route?.completed}
                                    onClick={() => {
                                        this.setState({loading: true})
                                        OrderActions.setRouteLocked(route._id, !_.every(route?.addresses, (address) => address.locked), (err) => {
                                            this.setState({loading: false, error: err})
                                        })
                                    }}
                                />

                                <Button
                                    style={{flex: 1}}
                                    variant='outline-white'
                                    icon='mdi mdi-check'
                                    label='Gereed'
                                    labelPosition='bottom'
                                    disabled={loading}
                                    onClick={async () => {
                                        OrderActions.setRouteReady(route._id, !route.ready, (err) => {
                                            if (err) {
                                                this.popup.open('Foutmelding')
                                                this.popup.setError(err)
                                            }

                                            this.setState({editRoute: false})
                                        })
                                    }}
                                />
                            </Row>

                            <FormStack style={{marginTop: formSpacing.rowGap, marginBottom: formSpacing.rowGap}}>
                                <ChooseRoutePoint
                                    label='Start:'
                                    dropdownLabel='Startpunt'
                                    reseller={reseller}
                                    user={user}
                                    address={route.startPoint}
                                    route={route}
                                    routeId={route._id}
                                    disabled={route.started || route.completed}
                                    onChange={(startPoint) => {
                                        this.setState({loading: true})

                                        OrderActions.updateRoute({startPoint}, (err) => {
                                            this.setState({loading: false, error: err})
                                        })
                                    }}
                                />

                                <ChooseRoutePoint
                                    label='Eind:'
                                    dropdownLabel='Eindpunt'
                                    reseller={reseller}
                                    user={user}
                                    address={route.endPoint}
                                    route={route}
                                    routeId={route._id}
                                    disabled={route.completed}
                                    onChange={(endPoint) => {
                                        this.setState({loading: true})

                                        OrderActions.updateRoute({endPoint}, (err) => {
                                            this.setState({loading: false, error: err})
                                        })
                                    }}
                                />
                            </FormStack>

                        </div>

                    </Panel>
                }

                {routeUpdatedNotifcation?.addedMessage &&
                    <Alert style={{marginBottom: 6}} variant='info' onClose={() => OrderActions.readNotification('added')}>
                        {routeUpdatedNotifcation.addedMessage}
                    </Alert>

                }

                {routeUpdatedNotifcation?.removedMessage &&
                    <Alert style={{marginBottom: 6}} variant='warning' onClose={() => OrderActions.readNotification('removed')}>
                        {routeUpdatedNotifcation.removedMessage}
                    </Alert>
                }

                {isScanning &&
                    <Row style={{height: 50, flexShrink: 0, alignItems: 'center', justifyContent: 'center'}} onClick={() => history.push('/koerier/scan')}>
                        <i style={{fontSize: 18, marginRight: 6}} className='mdi mdi-thumb-up-outline' />

                        <P>{`${route.readyColliCount} van ${route.allColliCount} colli zijn gereed om te starten`}</P>
                    </Row>
                }

                {isScanning &&
                    <Tabs variant='courier' style={{width: '100%', marginBottom: 6}} value={this.state.activeTab} onChange={(event) => this.setState({activeTab: event.target.value})}>
                        <Tab value='all'>{`Alle (${route.allColliCount || 0})`}</Tab>
                        <Tab value='ready'>{`Gereed (${route.readyColliCount || 0})`}</Tab>
                        <Tab value='open'>{`Open (${route.openColliCount || 0})`}</Tab>
                    </Tabs>
                }

                {!loading && !isScanning && !editRoute &&
                    <NextStopETA route={route} />
                }

                <ScrollContainer>
                    {loading &&
                        <Spinner style={{margin: 12}} />
                    }

                    {_.keys(routes).length === 0 &&
                        <H6 style={{marginBottom: 12, marginTop: 15}}>Geen routes</H6>
                    }

                    {editRoute &&
                        <SortableList
                            items={editRouteItems}
                            isDisabled={(item) => {
                                if (item.isBundle) {
                                    return item.addresses.some((address) => address.locked) || (fixedZoneLocked && item.anchor)
                                }

                                return item.hasArrived || item.locked || (fixedZoneLocked && !!item.anchor)
                            }}
                            renderItem={(address, index) => {
                                if (address.isBundle) {
                                    return (
                                        <AddressBundle
                                            reseller={reseller}
                                            route={route}
                                            bundle={address}
                                            compact={user.settings?.addressListStyle !== 'extended'}
                                            editRoute={editRoute}
                                        />
                                    )
                                }

                                const order = route.orders[address.orderId]

                                return (
                                    <Address
                                        reseller={reseller}
                                        route={route}
                                        address={address}
                                        compact={index === 0 && address.isReady && !address.hasArrived ? false : user.settings?.addressListStyle !== 'extended'}
                                        editRoute={editRoute}
                                        createdByMessenger={order?.createdByMessenger}
                                    />
                                )
                            }}
                            onChange={(items) => {
                                const addresses = items.flatMap((item) => item.isBundle ? item.addresses : [item])

                                // Stops can only be moved within the flexible part when the fixed zone may not be deviated from
                                if (fixedZoneLocked && !routeFixedZone.keepsFixedZone(route.addresses, addresses)) {
                                    return
                                }

                                OrderActions.planRoute(route._id, false, false, addresses)
                            }}
                        />
                    }

                    {!editRoute && _.keys(routes).length > 0 &&
                        <>
                            {(isScanning ? route.todoAddresses : route.todoItems)?.map((address, index) => {
                                if (address.isBundle) {
                                    return (
                                        <AddressBundle
                                            key={address.id}
                                            reseller={reseller}
                                            route={route}
                                            bundle={address}
                                            compact={index === 0 && address.isReady ? false : user.settings?.addressListStyle !== 'extended'}
                                            disabled={shiftStartRequired}
                                            onClick={this.onClickPickupDeliver.bind(this, address, '')}
                                            onClickAddress={(stop) => this.onClickPickupDeliver(stop, '')}
                                            onClickNavigation={(stop) => onClickNavigation(user, route, stop)}
                                            onClickMap={() => history.push('/koerier/kaart', {orderId: address.addresses[0].orderId, addressIndex: address.addresses[0].index})}
                                        />
                                    )
                                }

                                if (isScanning && this.state.activeTab === 'ready') {
                                    const isReady = address.colli.some((collo) => collo.ready)

                                    if (!isReady) {
                                        return
                                    }
                                }

                                if (isScanning && this.state.activeTab === 'open') {
                                    const isOpen = address.colli.some((collo) => !collo.ready)

                                    if (!isOpen) {
                                        return
                                    }
                                }

                                if (isScanning && !address.hasUnstartedColli) {
                                    return
                                }

                                return (
                                    <Address
                                        key={`address_${index}`}
                                        reseller={reseller}
                                        address={address}
                                        compact={index === 0 && address.isReady && !address.hasArrived ? false : user.settings?.addressListStyle !== 'extended'}
                                        showCollo={isScanning ? this.state.activeTab : ''}
                                        onClickNavigation={(address) => onClickNavigation(user, route, address)}
                                        onClickMap={() => history.push('/koerier/kaart', {orderId: address.orderId, addressIndex: address.index})}
                                        onClick={this.onClickPickupDeliver.bind(this, address, '')}
                                        disabled={shiftStartRequired}
                                        onSetColloReady={(collo) => {
                                            OrderActions.setColloReady(collo, !collo.ready, (err) => {
                                                if (err) {
                                                    this.setState({error: err})
                                                }
                                            })
                                        }}
                                        isSibling={(() => {
                                            if (route.optimized || route.addresses.some((addr) => typeof addr.priority === 'number')) {
                                                return false
                                            }

                                            const exists = route.addresses.findIndex((addr) => addr.orderId === address.orderId && addr._id !== address._id && addr.hasArrived === address.hasArrived) > -1

                                            return exists && address.index !== 0
                                        })()}
                                    />
                                )
                            })}

                            {!reseller?.settings?.orders?.autoCompleteRoutes && route.endPoint &&
                                <Address
                                    key='address_endpoint'
                                    reseller={reseller}
                                    address={{
                                        ...route.endPoint,
                                        isDepot: true,
                                        isReady: route.started,
                                        plannedTimeOfArrival: messengerEndPointTime(route),
                                        startTime: '00:00',
                                        endTime: '23:59'
                                    }}
                                    compact={true}
                                    showCollo={isScanning ? this.state.activeTab : ''}
                                    onClickNavigation={(address) => onClickNavigation(user, route, address)}
                                    onClickMap={() => history.push('/koerier/kaart', {focusEndPoint: true})}
                                    disabled={shiftStartRequired}
                                />
                            }

                            {route.completedAddresses?.map((address, index) => {
                                if (isScanning && this.state.activeTab === 'ready') {
                                    const isReady = address.colli.some((collo) => collo.ready)

                                    if (!isReady) {
                                        return
                                    }
                                }

                                if (isScanning && this.state.activeTab === 'open') {
                                    const isOpen = address.colli.some((collo) => !collo.ready)

                                    if (!isOpen) {
                                        return
                                    }
                                }

                                if (isScanning && !address.hasUnstartedColli) {
                                    return
                                }

                                return (
                                    <Address
                                        key={`completedAddress_${index}`}
                                        reseller={reseller}
                                        address={address}
                                        compact={index === 0 && address.isReady && !address.hasArrived ? false : user.settings?.addressListStyle !== 'extended'}
                                        showCollo={isScanning ? this.state.activeTab : ''}
                                        onClickNavigation={(address) => onClickNavigation(user, route, address)}
                                        onClickMap={() => history.push('/koerier/kaart', {orderId: address.orderId, addressIndex: address.index})}
                                        editable={canEditCompletedAddress(reseller.settings, route, address)}
                                        onClick={this.onClickEditCompletedAddress.bind(this, address)}
                                        disabled={shiftStartRequired}
                                        onSetColloReady={(collo) => {
                                            OrderActions.setColloReady(collo, !collo.ready, (err) => {
                                                if (err) {
                                                    this.setState({error: err})
                                                }
                                            })
                                        }}
                                        isSibling={(() => {
                                            if (route.optimized || route.addresses.some((addr) => typeof addr.priority === 'number')) {
                                                return false
                                            }

                                            const exists = route.addresses.findIndex((addr) => addr.orderId === address.orderId && addr._id !== address._id && addr.hasArrived === address.hasArrived) > -1

                                            return exists && address.index !== 0
                                        })()}
                                    />
                                )
                            })}
                        </>
                    }
                </ScrollContainer>

                <Popup ref={(ref) => this.popup = ref} />
                <SelectRoutePopup ref={(ref) => this.selectRoutePopup = ref} reseller={reseller} />
                <ColliNotReadyPopup ref={(ref) => this.colliNotReadyPopup = ref} />

                <AddAddressModal
                    ref={(ref) => this.addAddressModal = ref}
                    reseller={reseller}
                    branding={branding}
                    customers={customers}
                    addressBook={addressBook}
                    route={route}
                    shift={shift}
                    onClose={async () => {
                        if (!route.started) {
                            this.popup.setActionButtons([{
                                label: t('optimizeRoute'),
                                onClick: async () => {
                                    try {
                                        await emit('orders.planRoute', {routeId: route._id, optimize: true})
                                        this.popup.close()
                                    } catch (err) {
                                        this.popup.setError(err.message || err.toString())
                                    }
                                }
                            }])

                            if (!await this.popup.open('Route optimaliseren', 'Route is niet geoptimaliseerd. Wil je de route optimaliseren?')) return
                        }
                    }}
                />
            </>
        )
    }
}
